import { TableRow, TableRowBehavior, TableRowMode, TableRowToolsCell } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";

export class AppTableRowBehavior extends TableRowBehavior {
    protected constructor() {
        super();
    }

    override allowsEdit(tableRow: TableRow, rowAllowsEdit: boolean): boolean {
        if (tableRow.mode === TableRowMode.QUICK_ADD) {
            // App UI does not support add/edit in-line for quick add tables.
            if (!StringUtil.isEmptyString(tableRow.table.editLayout))
                return false;
        }
        return super.allowsEdit(tableRow, rowAllowsEdit);
    }

    manageEditStateOnModeChange(tableRow: TableRow, mode: TableRowMode): void {
        if (mode === TableRowMode.UPDATE) {
            tableRow.showEditLayout();
        } else {
            super.manageEditStateOnModeChange(tableRow, mode);
        }
    }

    override addToolsCellToRow(row: TableRow, cell: TableRowToolsCell): void {
        // NOP - ToolsCell only visible during swipe user action (See AppTableRowToolsCellReveal)
    }
}

AppTableRowBehavior.register();
